/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $MatchTypeUnion = {
    type: 'one-of',
    contains: [{
        type: 'MatchLeague',
    }, {
        type: 'MatchTournamentStage',
    }, {
        type: 'MatchTournamentGroup',
    }],
} as const;
